import React, { Component } from "react";
import Joi from "joi-browser";
import Form from "../common/form";
import {
  generateRoomReport,
  generateRoomMonthlyEntries,
} from "../../services/reportService";
import { toast } from "react-toastify";

import BlockUi from "react-block-ui";
import { Table, Button, Message, Label, Confirm } from "semantic-ui-react";
import TableTitle from "../common/tableTitle";
import auth from "../../services/authService";

class RoomReport extends Component {
  state = {
    transactions: [],
    showSalaryForm: false,
    showError: false,
    confirmMsg:
      "Are you sure, you want to create rent entries of all the accounts in the report for the date [" +
      new Date() +
      "]",
    open: false,
  };

  handleCancel = () => {
    this.setState({ open: false });
  };

  async componentDidMount() {
    this.setState({ blocking: true });
    const { data: res } = await generateRoomReport();

    this.setState({ blocking: false, transactions: res });
  }

  doConfirmOrder = async () => {
    this.setState({ blocking: true });
    await generateRoomMonthlyEntries();
    this.setState({ blocking: false, open: false });
    toast.success("Entries has been done successfully.");
  };

  render() {
    if (auth.getCurrentUser().role != "client") {
      return "Your are authorized to perform this action.";
    }
    const { transactions } = this.state;
    return (
      <BlockUi tag="div" blocking={this.state.blocking}>
        <Confirm
          open={this.state.open}
          header="Confirmation"
          content={this.state.confirmMsg}
          onCancel={this.handleCancel}
          onConfirm={this.doConfirmOrder}
          size="mini"
        />
        <TableTitle title="Room Report" icon="tag" />
        <center>
          <Button
            className="ui primary button"
            onClick={() => this.setState({ open: true })}
          >
            Generate Entries
          </Button>
          <div
            className="ui error form"
            style={{
              width: "90%",
              marginTop: "20px",
            }}
          >
            <Table celled fixed singleLine>
              <Table.Header>
                <Table.Row>
                  <Table.HeaderCell width={4}>Name</Table.HeaderCell>
                  <Table.HeaderCell width={2}>Mobile Type</Table.HeaderCell>
                  <Table.HeaderCell width={6}>Company</Table.HeaderCell>
                  <Table.HeaderCell width={2}>Rent</Table.HeaderCell>
                  <Table.HeaderCell width={2}>Balance</Table.HeaderCell>
                </Table.Row>
              </Table.Header>

              <Table.Body>
                {transactions.map((transaction) => (
                  <Table.Row>
                    <Table.Cell>{transaction.name}</Table.Cell>
                    <Table.Cell>{transaction.mobile}</Table.Cell>
                    <Table.Cell>{transaction.company}</Table.Cell>
                    <Table.Cell>{transaction.rent}</Table.Cell>
                    <Table.Cell>{transaction.balance}</Table.Cell>
                  </Table.Row>
                ))}
              </Table.Body>
            </Table>
            <br />
          </div>
        </center>
      </BlockUi>
    );
  }
}

export default RoomReport;
